<template>
  <div class="flex flex-col items-center justify-center w-82">
    <img
      :src="getImageUrl('header/settings/about/updateFail.png')"
      alt="updateSuccess"
      class="size-52.5"
    />
    <div class="text-center mt-4">
      <h3 class="text-m-medium text-state-failure">
        {{ $t('setting.about.update.checkUpdateDialog.UpdateError') }}
      </h3>
    </div>

    <Button class="w-full mt-6" color="black" size="lg" @click="$emit('close')">
      {{ $t('common.confirm') }}
    </Button>
  </div>
</template>

<script setup lang="ts">
  import { Button } from '@rapoo/element'
  import { getImageUrl } from '@/utils/assets'

  defineEmits<{
    (e: 'close'): void
  }>()
</script>
